import { AlertCircle } from "lucide-react";

export default function Field({ label, htmlFor, error, required, children, hint }) {
    const errorId = error ? `${htmlFor}-error` : undefined;
    return (
        <div>
            <label
                htmlFor={htmlFor}
                className="block text-[10.5px] tracking-[0.32em] uppercase text-[#9A958A] mb-3"
            >
                {label}
                {required && (
                    <span aria-hidden="true" className="text-[#C9A86A] ml-1">
                        *
                    </span>
                )}
            </label>
            {children}
            {hint && !error && (
                <p className="mt-2 text-[11px] text-[#6e6a62]">{hint}</p>
            )}
            {error && (
                <p
                    id={errorId}
                    role="alert"
                    className="mt-2 flex items-center gap-2 text-[12px] text-[#C97A6A]"
                >
                    <AlertCircle size={12} strokeWidth={1.6} />
                    {error}
                </p>
            )}
        </div>
    );
}
